import { useState } from 'react'
import { Prose } from '../../components/prose'
import type { EvalAction } from '../types'
import { SeverityTag } from './severity-tag'

const DEFAULT_VISIBLE_COUNT = 3

export interface EvaluationActionsProps {
  actions: EvalAction[]
}

export function EvaluationActions({ actions }: EvaluationActionsProps) {
  const [showAll, setShowAll] = useState(false)
  const visible = showAll ? actions : actions.slice(0, DEFAULT_VISIBLE_COUNT)
  const hasHidden = actions.length > DEFAULT_VISIBLE_COUNT

  return (
    <div className="mt-6 rounded-xl border border-border bg-card/30">
      <div className="border-b border-border px-5 py-3">
        <h3 className="text-sm font-semibold text-foreground">Recommended Actions</h3>
        <p className="mt-0.5 text-[10px] text-muted-foreground/80">
          Prioritized by impact on investor readiness
        </p>
      </div>
      <div className="divide-y divide-border">
        {visible.map((action, i) => (
          <div key={action.title} className="flex items-start gap-4 px-5 py-4">
            <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-[#f97316]/10 text-xs font-bold text-[#f97316]">
              {i + 1}
            </span>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <p className="text-sm font-medium text-foreground">{action.title}</p>
                {action.severity && <SeverityTag severity={action.severity} />}
              </div>
              <Prose className="mt-0.5 text-xs text-muted-foreground">{action.detail}</Prose>
            </div>
          </div>
        ))}
      </div>
      {hasHidden && !showAll && (
        <button
          type="button"
          onClick={() => setShowAll(true)}
          className="w-full border-t border-border px-5 py-2.5 text-xs text-muted-foreground transition-colors hover:text-foreground hover:bg-white/[0.02]"
        >
          Show all ({actions.length})
        </button>
      )}
    </div>
  )
}
